<template>
  <div class="content my-0 py-1">
    <div class="container-fluid">
      <div class="row">
          <div class="col-12  mt-2 py-0">
              <h4 class="m-0 p-0 text-secondary d-inline">Form Data Vendor</h4>
          </div>
          <transition name="fade">
            <div class="col-12  my-2 py-0">
                <div class="row p-3 mx-2 bg-white shadow">
                    <div class="col-12 col-md-6 col-lg-4 mt-2">
                        <label class="d-block">Nama Vendor <span style="color:red;">*</span></label>
                        <input type="text"  class="form-control w-100 rounded" v-model="newvendor.vendorName" />
                    </div>
                    <div class="col-12 col-md-6 col-lg-4 mt-2">
                        <label class="d-block">Telepon <span style="color:red;">*</span></label>
                        <input type="number"  class="form-control w-100 rounded" v-model="newvendor.telp" />
                    </div>
                    <div class="col-12 col-md-6 col-lg-4 mt-2">
                        <label class="d-block">Email <span style="color:red;">*</span></label>
                        <input type="text"  class="form-control w-100 rounded" v-model="newvendor.email" />
                    </div>
                    <div class="col-12 col-md-6 col-lg-4 mt-2">
                        <label class="d-block">Alamat <span style="color:red;">*</span></label>
                        <textarea type="text"  class="form-control w-100 rounded" v-model="newvendor.address" />
                    </div>
                    <div class="col-12 mt-3">
                        <div class="w-100 align-items-center justify-content-start" v-if="newvendorSaved">
                            <div class="alert alert-success" role="alert">
                                Berhasil menyimpan vendor baru.
                            </div>
                        </div>
                    </div>
                    <div class="col-12 mt-3">
                        <div class="w-100 align-items-center justify-content-start" v-if="errorNewvendor">
                            <div class="alert alert-danger" role="alert">
                                <div class="my-0">
                                    <p  class="d-block mt-1">Gagal menyimpan vendor baru.</p>
                                </div>
                                <div v-for="err in errorNewvendorList" v-bind:key="err" class="my-0">
                                    <p  v-for="note in err" v-bind:key="note" class="d-block mt-1">{{note}}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 mt-3">
                        <div class="d-flex align-items-center justify-content-start" v-if="savingNewvendor">
                            <div class="spinner-border" role="status" aria-hidden="true"></div>
                            <strong class=" ml-2">Menyimpan data, tunggu sebentar.</strong>
                        </div>
                        <button class="btn btn-primary float-right" type="button" v-on:click="saveNewvendor">Submit</button>
                    </div>
                </div>
            </div>
            </transition>
      </div>
    </div>

  </div>
</template>
<script>
//   import ChartCard from 'src/components/Cards/ChartCard.vue'
//   import StatsCard from 'src/components/Cards/StatsCard.vue'
//   import LTable from 'src/components/Table.vue'
    import {EventBus} from '../../eventbus'
    import * as axios from 'axios';
    import Datatable from '../../components/Datatable.vue';
    import SmartSelect from '../../components/SmartSelect.vue';
    import ModalDelete from '../../components/ModalDelete.vue';
    export default {
        components: {
        //   LTable,
        //   ChartCard,
        //   StatsCard
            'datatable':Datatable,
            'smart-select':SmartSelect,
            'modal-delete':ModalDelete
        },
        data () {
            return {
                 isMobile:false,

                //step 1 edit
                dataEdit:null,
                datatable:{
                    loadData:false
                },
                newvendor:{
                    vendorName:'',
                    telp:'',
                    email:'',
                    address:''
                },
                itemToDelete:{},
                deleteId:0,
                errorvendorSaved:false,
                updatevendorSaved:false,
                editvendorState:false,
                deletevendorState:false,
                failDeletevendor:false,
                vendorDeleted:false,
                Mastervendors:[],
                errorNewvendorList:[],
                formNewvendor:false,
                errorNewvendor:false,
                savingNewvendor:false,
                newvendorSaved:false,
                searchValue:'',
                selectedToDelete:0,
                selectedvendor:0,
                MastervendorTableStructure:[
                    {label:'No',key:null},
                    {label:'Nama Vendor',key:null},
                    {label:'Telepon',key:null},
                    {label:'Email',key:null},
                    {label:'Alamat',key:null},
                    {label:'Tindakan',key:null}
                ]
            }
        },
        created(){
            console.clear()
            console.log("vendor page")
            
            console.log(window.opener.App)
            this.getMastervendors();
        },
        methods:{
            deleteResult(deleted){
                console.log(deleted)
                if(deleted){
                    this.getMastervendors();
                }
            },
            getMastervendors(url=(this.$baseUrl+'/api/master/vendor')){
                this.datatable.loadData=true;
                axios.get(url,{'headers':{
                        'Authorization':'Bearer '+localStorage.getItem('accessToken')
                    }
                }).then((result)=>{
                    console.log(result)
                    this.datatable.loadData=false;
                    this.Mastervendors = result.data.data;
                }).catch((err)=>{
          //check if token fail
          if(err.response && err.response.status==401){
            localStorage.removeItem('accessToken')
          this.$router.push('/login')
          }
                    console.log(err)
                    this.datatable.loadData=false;
                })
            },
            updatevendorItemType(value){
                this.Mastervendors[this.selectedvendor].item=value;
            },
            updateNewvendorItemType(value){
                this.newvendor.itemType=value;
            },
            saveNewvendor(){
                this.savingNewvendor=true
                this.errorNewvendor=false
                this.errorNewvendorList=[]
                if(this.newvendor.vendorName==''){
                    this.errorNewvendorList.push(["- Mohon isi nama"])
                }
                if(this.newvendor.telp==''){
                    this.errorNewvendorList.push(["- Mohon isi nomor telepon"])
                }
                if(this.newvendor.email==''){
                    this.errorNewvendorList.push(["- Mohon isi email"])
                }
                if(this.newvendor.address==''){
                    this.errorNewvendorList.push(["- Mohon isi alamat  "])
                }
                console.log(this.newUser)
                if(this.newvendor.vendorName!='' && this.newvendor.itemType!=''){
                    
                    axios.post(this.$baseUrl+'/api/master/vendor',
                    {
                        vendor_name:this.newvendor.vendorName,
                        vendor_telphone:this.newvendor.telp,
                        vendor_email:this.newvendor.email,
                        vendor_address:this.newvendor.address,
                    },
                    {
                        'headers':
                        {
                            'Authorization':'Bearer '+localStorage.getItem('accessToken')
                        }
                    }).then((result)=>{
                        //console.log(result)
                        //this.$emit('createvendor','hello')
                        if(result.data.create){
                            window.opener.EventBus.$emit('newvendor',result.data.data)
                            //window.opener.App.assignNewVendor(result.data)
                            //this.getMastervendors();
                            // localStorage.setItem('datavendor',JSON.stringify(result.data))
                            // window.opener.postMessage(message);
                        }
                        this.newvendor.vendorName='',
                        this.newvendor.telp='',
                        this.newvendor.email='',
                        this.newvendor.address='',
                        this.savingNewvendor=false
                        this.newvendorSaved=true

                        setTimeout(() => {
                            this.newvendorSaved=false
                            this.formNewvendor=false
                            window.close()
                        }, 1000);

                    }).catch((err)=>{
          //check if token fail
          if(err.response && err.response.status==401){
            localStorage.removeItem('accessToken')
          this.$router.push('/login')
          }
                        if(err.response!=undefined){
                            console.log(err.response)
                            this.errorNewvendorList=[]
                            this.errorNewUserList=Object.values(err.response.data.errors)
                            console.log(this.errorNewUserList)
                            this.errorNewvendor=true
                            this.savingNewvendor=false
                        }else{
                            console.log(err)
                        }
                    })
                }else{
                    this.errorNewvendor=true
                    this.savingNewvendor=false
                }
            }
        },
    }
</script>
<style scoped>
.btn {
    padding: 5px 10px;
}
::v-deep .modal-content {
    margin: -3.25rem auto;
}

/* MENGHILANGKAN ICON NUMBER BAWAAN TYPE */
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}
</style>
